import React from 'react';
import { ReportedIssueModal } from './reported-issue-modal.component';
import { useReportedIssueModalService } from './reported-issue-modal.service';
import type { ReportedIssueModalContainerProps } from './reported-issue-modal.types';

export const ReportedIssueModalContainer = (
  props: ReportedIssueModalContainerProps,
) => {
  const serviceProps = useReportedIssueModalService(props);
  return <ReportedIssueModal {...serviceProps} />;
};
